import React, { useState } from 'react'
import Header from './Header'
import Footer from './Footer'

import { useNavigate } from 'react-router-dom'
import {LoginApi} from '../service/api'

const Login = () => {
 

  let [data,setData] = useState({
      email:"",
      password:""
  })
  const [errors, setErrors] = useState({});
  const [msg,setMsg] = useState("")
  const [clr,setClr] = useState({color:""})
  let nav = useNavigate()

  let changeInput = (e)=>{
    //console.log(e)
    setData({
      ...data,
      [e.target.name]: e.target.value
    })
  }

  const validate =()=>{
      const newErrors = {};
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i;
      // Email validation
      
      if (!data.email) {
        newErrors.email = 'Email is required';
      } else if (!emailRegex.test(data.email)) {
        newErrors.email = 'Email is not valid';
      }

      

    // Password validation
    if (!data.password) {
      newErrors.password = 'Password is required';
    }

    setErrors(newErrors)

    // Returns true if there are no errors
    return Object.keys(newErrors).length === 0;

  }


  let login = (e)=>{
    e.preventDefault()
    if (validate()) {
      //console.log('Form submitted:', data);
      //setMsg("Login Success")
      let {email,password} = data

      let d = new FormData()
     
      d.append("userEmail",email)
      d.append("userPassword",password)

      LoginApi(d).then((res)=>{
        console.log(res.data)
        let {status,message} = res.data

        setMsg(message)
        if(status === 1){
          setClr({color:"green"})
          localStorage.setItem("x",data.email)
          setTimeout(()=>{
            nav('/dashboard')
          },2000)
          
        }else{
          setClr({color:"red"})
        }
      }).catch((errors)=>{
        console.log(errors)
      })
    }
  }


  return (
    <> 
    {/*comments */}
      <Header />
      <div className="container">
        <div className="row mt-5">
          <div className="col-md-6 mx-auto">
            <div className="card">
              <div className="card-header">
                <h1>Login </h1>
                <p>{JSON.stringify(data)}</p>
              </div>
              <div className="card-body">
                <form>
                  

                 

                  <div className="mb-3">
                    <label htmlFor="email" className="form-label">Email: </label>
                    <input type="email" className="form-control" placeholder="Enter enter Email" name="email"  onChange={changeInput}/>
                    {errors.email && <p className='fw-bold text-danger'>{errors.email}</p>}
                  </div>

                  

                  <div className="mb-3">
                    <label htmlFor="password" className="form-label">Password: </label>
                    <input type="password" className="form-control" placeholder="Enter enter password" name="password"  onChange={changeInput}/>
                    {errors.password && <p className='fw-bold text-danger'>{errors.password}</p>}
                  </div>

                  <button type="submit" class="btn btn-primary me-2" onClick={login}>Login</button>
                  <button type="reset" class="btn btn-danger">Cancel</button>
                  <p className='mt-4 fw-bold'style={clr}>{msg}</p>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  )
}

export default Login
